<template>
    <div>
        <headerNotice routerName="商品列表"></headerNotice>
        <!-- 搜索栏 -->
        <div class="searchBox">
            <el-row :gutter="24">
                <!-- 搜索框 -->
                <el-col :span="5" :offset="0">
                    <el-input placeholder="请输入名称/编号/规格/规格编号" v-model="serachForm.keyword">
                        <el-button slot="append" icon="el-icon-search" @click="serachIt"></el-button>
                    </el-input>
                </el-col>
                <!-- 分类搜索 -->
                <el-col :span="4" :offset="0">
                    <el-cascader change-on-select :options="cateList" :props="cateProps" @change="cateSearch"></el-cascader>

                    <!-- <el-select v-model="serachForm.cateID" @change="cateSearch" placeholder="请选择分类">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option
                            v-for="item in cateList"
                            :key="item.cateID"
                            :label="item.cateName"
                            :value="item.cateID"
                        ></el-option>
                    </el-select>-->
                </el-col>
                <!-- 标签搜索 -->
                <el-col :span="4" :offset="0">
                    <el-select
                        v-model="serachForm.labelID"
                        @change="tagSearch"
                        placeholder="请选择商品标签"
                    >
                        <el-option label="全部" :value="0"></el-option>
                        <el-option
                            v-for="item in labelList"
                            :key="item.labelID"
                            :label="item.labelName"
                            :value="item.labelID"
                        ></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </div>
        <!-- 数据表格 -->
        <div class="dataTable" v-loading="loading">
            <!-- 多选操作 -->
            <div style="margin-bottom: 20px">
                <span class="notice" v-if="choosedItem.length">
                    已经选择
                    <i>{{choosedItem.length}}</i> 项
                </span>
                 <el-button type="success" @click="confirmAudit(0)">批量审核通过</el-button>
                  <el-button type="info" @click="confirmAudit(2)">批量审核不通过</el-button>
            </div>
            <el-table
                class="tableBox"
                :data="goodsList"
                style="width: 100%"
                :default-sort="{prop: 'date', order: 'descending'}"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column align="center" prop="itemID" label="商品ID" width="70"></el-table-column>
                <el-table-column align="center" label="商品图片/名称/编号/标签" width="400">
                    <template align="center" slot-scope="scope">
                        <div class="goodBaseInfo">
                            <img :src="baseUrl+scope.row.imgUrl" alt width="50" height="50">
                            <div class="txtInfo">
                                <p class="title">{{scope.row.title}}</p>
                                <p class="itemCode">{{scope.row.itemCode}}</p>
                                <div class="tags">
                                    <!-- <el-popover trigger="hover" placement="bottom" width="100">
                                        <p>请选择标签，每个商品最多3个</p>
                                        <el-checkbox-group
                                            v-model="scope.row.labels"
                                            :min="0"
                                            :max="3"
                                            class="goodsListCheckBox"
                                            @change="singleGoodsTagChange"
                                        >
                                            <el-checkbox
                                                v-for="(item,index) in labelList"
                                                :key="index"
                                                :label="item"
                                            >{{item.labelName}}</el-checkbox>
                                        </el-checkbox-group>
                                        <span
                                            @mouseenter="getCurrentCheckItemID(scope.row.itemID)"
                                            slot="reference"
                                        >+标签</span>
                                    </el-popover>-->
                                    <span
                                        :style="{'backgroundColor':item.color}"
                                        v-for="(item,index) in scope.row.labels"
                                        :key="index"
                                    >{{item.labelName}}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column align="center" prop="cateName" label="分类"></el-table-column> -->
                <el-table-column align="center" width="150" label="上/下架">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            :active-value="1"
                            :inactive-value="0"
                            active-text="上架"
                            inactive-text="下架"
                            @change="switchChange(scope.$index,scope.row.itemID,scope.row.status)"
                        ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="propNum" label="规格数量"></el-table-column>
                <el-table-column align="center" prop="unit" label="单位"></el-table-column>
                <el-table-column align="center" prop="stock" label="库存" width="100" sortable></el-table-column>
                 <el-table-column align="center" label="审核状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isAudit == 1">未审核</span>
                            <span v-else-if="scope.row.isAudit == 0">通过</span>
                            <span v-else>拒绝</span>
                        </template>
                    </el-table-column>
                <el-table-column align="center" prop="price" label="销售价" width="100" sortable></el-table-column>
                <el-table-column align="center" prop="sales" label="总销量" width="100" sortable></el-table-column>
                <el-table-column align="center" label="操作" width="250">
                    <template slot-scope="scope">
                        <el-button @click="editClick(scope.row)" size="small">修改</el-button>
                        <el-button @click="deleteClick(scope.row,scope.$index)" size="small">删除</el-button>
                        
                    </template>
                </el-table-column>
            </el-table>
          
            <!--分页-->
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[25, 50, 75, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
        </div>

        <!-- 高级搜索dialog框 -->
        <el-dialog title="高级搜索" class="searchDialog" :visible.sync="searchDialog" width="50%">
            <el-form :model="serachForm" class="signUp_Form" label-width="125px">
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="商品名称：">
                            <el-input class="inputStyle" v-model="serachForm.title" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="商品编号：">
                            <el-input class="inputStyle" v-model="serachForm.itemCode" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="规格名称：">
                            <el-input class="inputStyle" v-model="serachForm.propName" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="规格编号：">
                            <el-input class="inputStyle" v-model="serachForm.propCode" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="分类：">
                            <el-cascader
                                :options="cateList"
                                :props="cateProps"
                                change-on-select
                                @change="cateHighSearch"
                            ></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="商品标签：">
                            <el-select v-model="serachForm.labelID" placeholder="请选择商品标签">
                                <el-option label="全部" :value="0"></el-option>
                                <el-option
                                    v-for="item in labelList"
                                    :key="item.labelID"
                                    :label="item.labelName"
                                    :value="item.labelID"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="10">
                        <el-form-item label="品牌：">
                            <el-select v-model="serachForm.brandID" placeholder="请选择商品品牌">
                                <el-option label="全部" :value="0"></el-option>
                                <el-option
                                    v-for="item in brandList"
                                    :key="item.brandID"
                                    :label="item.brandName"
                                    :value="item.brandID"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="商品条形码：">
                            <el-input class="inputStyle" v-model="serachForm.barCode" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="20">
                        <span>销售价：</span>
                        <input v-model="serachForm.minPrice" size="small">&nbsp;&nbsp; - &nbsp;&nbsp;
                        <input
                            v-model="serachForm.maxPrice"
                            size="small"
                        >
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="商品状态：">
                            <el-radio-group v-model="serachForm.status">
                                <el-radio :label="2">全部</el-radio>
                                <el-radio :label="1">上架</el-radio>
                                <el-radio :label="0">下架</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="searchDialogBtn">
                <el-button @click="clearSerachForm">清空</el-button>
                <el-button class="dialogConfirmBtn" @click="searchDialogConfirm" type="primary">确认</el-button>
            </div>
        </el-dialog>

        <!-- 库存详情dialog框 -->
        <el-dialog
            title="库存详情"
            v-loading="loading"
            class="searchDialog"
            :visible.sync="sorteHouseDialog"
            width="50%"
        >
            <el-table
                :data="storeList"
                style="width: 100%"
                :default-sort="{prop: 'date', order: 'descending'}"
                @selection-change="handleSelectionChange"
            >
                <el-table-column align="center" label="规格图" width="120">
                    <template slot-scope="scope">
                        <img :src="baseUrl+scope.row.imgUrl" alt width="100" height="100">
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="propName" label="规格名称"></el-table-column>
                <el-table-column align="center" prop="propCode" label="规格编号"></el-table-column>
                <el-table-column align="center" prop="houseName" label="所属仓库"></el-table-column>
                <el-table-column align="center" prop="unit" label="单位"></el-table-column>
                <el-table-column align="center" prop="stock" label="库存" width="100" sortable></el-table-column>
            </el-table>
        </el-dialog>

        <!-- 批量设置标签dialog框 -->
        <el-dialog title="批量设置标签" class="setTagsDialog" :visible.sync="setTagsDialog" width="30%">
            <p class="tagNotice">请选择标签，最多选择3个!</p>
            <el-checkbox-group v-model="tagsDialogData" :min="0" :max="3">
                <el-checkbox
                    v-for="(item,index) in labelList"
                    :key="index"
                    :label="item"
                >{{item.labelName}}</el-checkbox>
            </el-checkbox-group>
            <div class="tagsDialogBtn">
                <el-button @click="cancelBtn">取消</el-button>
                <el-button @click="confirmSetAllTags" type="primary">确认</el-button>
            </div>
        </el-dialog>


         <!-- 审核dialog框
        <el-dialog title="批量设置标签" class="setTagsDialog" :visible.sync="AuditDialog" width="30%">
            <p class="tagNotice">请选择是否通过审核!</p>
           
            <div class="tagsDialogBtn">
                <el-button @click="cancelBtn">不通过</el-button>
                <el-button @click="confirmAudit" type="primary">通过</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            baseUrl: this.$store.state.apiUrl,
            loading: true,
            totalCount: 0,//总数据条数
            currentPage: 1,
            maxResultCount: 25, //默认一页显示的个数,
            cateList: [],//所有分类数据
            cateProps: {
                value: 'cateID',
                label: 'cateName',
                children: 'cates',
            },
            labelList: [],//所有变标签数据
            unitList: [],//所有单位数据
            brandList: [],//所有品牌数据
            goodsList: [],//商品列表主数据
            storeList: [],//库存详情数据
            isdisabledSwitch: false,//是否禁用上下架
            searchDialog: false,//是否显示高级搜索弹框
            serachForm: {//高级搜索弹框数据
                'keyword': '',
                'title': '',
                'itemCode': '',
                'propName': '',
                'propCode': '',
                'cateID': 0,
                'labelID': 0,
                'brandID': 0,
                'barCode': '',
                'minPrice': 0,
                'maxPrice': 0,
                'status': 2,
            },
            sorteHouseDialog: false,//是否显示库存详情弹框
            currentCheckItemID: 0,//当前准备设置标签的itemID
            choosedItem: [],//已选择的商品列表
            setTagsDialog: false,//批量设置标签弹框
            tagsDialogData: [],
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
            Status: 2,
        })
        //获取所有分类下拉
        this.getSelectDatas();
        this.getCates();
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            params.isAudit=1;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminItem/GetItemList",
                params: params,
                success(res) {
                    self.goodsList = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //获取所有分类下拉
        getSelectDatas() {
            let self = this;
            //获取分类
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminItem/GetCLUBList",
                success(res) {
                    // self.cateList = res.cateList;
                    self.brandList = res.brandList;
                    self.labelList = res.labelList;
                    self.unitList = res.unitList;
                },
                fail(res) {
                }
            })
        },
        //获取所有分类下拉
        getCates() {
            let self = this;
            //获取分类
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminCate/GetCate",
                success(res) {
                    self.cateList = res;
                    self.cateList.unshift({
                        cateName: '全部',
                        cateID: 0,
                        id: 0,
                        cates: [
                            {
                                cateName: '全部',
                                cateID: 0,
                                id: 0,
                                cates: null,
                            }
                        ],
                    })
                },
                fail(res) {
                }
            })
        },
        //名字 编号等搜索
        serachIt() {
            this.loading = true;
            this.getDatas({
                MaxResultCount: this.maxResultCount,
                skipCount: 0,
                Keyword: this.serachForm.keyword,
                Status: 2
            })
            this.currentPage = 1
        },
        //分类改变搜索
        cateSearch(val) {
            if (val.length == 2) {
                this.serachForm.cateID = val[1];
            } else {
                this.serachForm.cateID = val[0];
            }
            this.getDatas({
                MaxResultCount: this.maxResultCount,
                skipCount: 0,
                CateID: this.serachForm.cateID,
                Status: 2,
                LabelID:this.serachForm.labelID
            });
        },
        //高级搜索获取值
        cateHighSearch(val) {
            if (val.length == 2) {
                this.serachForm.cateID = val[1];
            } else {
                this.serachForm.cateID = val[0];
            }
        },
        //标签改变搜索
        tagSearch() {
            this.getDatas({
                cateID:this.serachForm.cateID,
                MaxResultCount: this.maxResultCount,
                skipCount: 0,
                LabelID: this.serachForm.labelID,
                Status: 2,
            });
            this.currentPage = 1
        },
        //高级搜索dialog弹框
        advancedSearch() {
            this.searchDialog = true;
        },
        //清空高级搜索数据
        clearSerachForm() {
            this.serachForm = {//高级搜索弹框数据
                'keyword': '',
                'title': '',
                'itemCode': '',
                'propName': '',
                'propCode': '',
                'cateID': 0,
                'labelID': 0,
                'brandID': 0,
                'barCode': '',
                'minPrice': 0,
                'maxPrice': 0,
                'status': 2,
                'skipCount': 0,
            };
        },
        //高级搜索确认
        searchDialogConfirm() {
            let params = this.serachForm;
            params.MaxResultCount = this.maxResultCount;
            params.skipCount = 0;
            this.searchDialog = false;
            this.getDatas(params);
            this.currentPage = 1
        },
        //单个商品标签设置
        singleGoodsTagChange(item) {
            if (item.length) {
                let labelIDs = []
                item.forEach((ele, index) => {
                    labelIDs.push(ele.labelID)
                });
                let params = {
                    itemIDs: [this.currentCheckItemID],
                    labelIDs: labelIDs,
                }
                this.setTagsRequset(params)
            }
        },
        //获取当前准备设置标签的商品itemID
        getCurrentCheckItemID(id) {
            this.currentCheckItemID = id;
        },
        //设置标签的请求方式 单个 批量
        setTagsRequset(params) {
            let self = this;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminItem/SetLabelVol",
                data: params,
                success(res) {
                    self.$message({
                        message: '设置成功',
                        type: 'success'
                    });
                    self.setTagsDialog = false;
                    self.loading = true;
                    self.getDatas({
                        MaxResultCount: self.maxResultCount,
                        Status: 2,
                    })
                    self.currentPage = 1
                },
                fail(res) {
                }
            })
        },
        //新增商品
        addGoods() {
            this.$router.push({
                'path': '/addGoods'
            })
        },
        // 同步ERP
        SyncStockERP() {
            let self = this;
            let data = [];
            if(self.choosedItem.length) {
                data = self.choosedItem.map((item) => {
                    return item.itemID
                })
            }
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminErp/SyncStock",
                data: data,
                success(res) {
                    self.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                },
                fail(res) {
                }
            })
        },
        //单个操作是否禁用监听  上下架
        switchChange(index, id, val) {
            let self = this;
            this.isdisabledSwitch = true;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminItem/ShelvesItem",
                data: {
                    itemID: [id],
                    shelves: val
                },
                success(res) {
                    self.goodsList[index].status = val;
                    self.isdisabledSwitch = false;
                    self.$forceUpdate();
                },
                fail(res) {
                    self.isdisabledSwitch = false
                }
            })
        },
        //批量上下架
        toggleShelvesItem(status) {
            let self = this;
            if (this.choosedItem.length) {
                let txt = `确认将选中的商品全部${status == 1 ? '上' : '下'}架吗?`
                this.$confirm(txt, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let itemIDArr = [];
                    self.choosedItem.forEach((ele, index) => {
                        itemIDArr.push(ele.itemID);
                    })
                    $http.POST({
                        url: this.$store.state.apiUrl + "/api/services/app/AdminItem/ShelvesItem",
                        data: {
                            itemID: itemIDArr,
                            shelves: status
                        },
                        success(res) {
                            self.choosedItem.forEach((ele, index) => {
                                ele.status = status;
                            })
                            self.$message({
                                type: 'success',
                                message: `${status == 1 ? '上' : '下'}架成功`
                            });
                            self.$forceUpdate();
                        },
                        fail(res) {

                        }
                    })
                }).catch(() => {

                });

            } else {
                this.$message.error('请先选择商品！');
                return;
            }
        },
        //打开批量设置标签dialog弹框
        openTagDialog() {
            if (this.choosedItem.length) {
                this.setTagsDialog = true;
            } else {
                this.$message.error('请先选择商品！');
                return;
            }
        },
        //关闭批量设置标签dialog弹框
        cancelBtn() {
            this.setTagsDialog = false;
        },
        //批量设置标签确定
        confirmSetAllTags() {
            if (this.tagsDialogData.length) {
                let itemsIDsArr = [];
                let labelIDsArr = [];
                this.choosedItem.forEach((ele, index) => {
                    itemsIDsArr.push(ele.itemID)
                });
                this.tagsDialogData.forEach((ele, index) => {
                    labelIDsArr.push(ele.labelID)
                });
                let params = {
                    itemIDs: itemsIDsArr,
                    labelIDs: labelIDsArr,
                }
                this.setTagsRequset(params);
            } else {
                this.$message.error('请先勾选需要设置的标签！');
                return;
            }
        },
         //审核
        confirmAudit(status) {
          let self = this;
            if (this.choosedItem.length) {
                let txt = `确认将选中的商品全部${status == 0 ? '' : '不'}通过审核吗?`
                this.$confirm(txt, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let itemIDArr = [];
                    self.choosedItem.forEach((ele, index) => {
                        itemIDArr.push(ele.itemID);
                    })
                    $http.POST({
                        url: this.$store.state.apiUrl + "/api/services/app/AdminItem/ModifyAuditStatus",
                        data: {
                            itemID: itemIDArr,
                            isAudit: status
                        },
                        success(res) {
                            self.$message({
                                type: 'success',
                                message: `${status == 0 ? '' : '不'}通过审核成功`
                            });
                            self.serachForm.MaxResultCount = self.maxResultCount
                            self.getDatas(self.serachForm);
                            self.currentPage = 1
                            self.loading = false;
                        },
                        fail(res) {

                        }
                    })
                }).catch(() => {

                });

            } else {
                this.$message.error('请先选择商品！');
                return;
            }
          
        },
        //批量清空标签
        delAlltags() {
            let self = this;
            if (this.choosedItem.length) {
                this.$confirm('确认将所勾选的全部清空标签吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let itemsIDsArr = [];
                    self.choosedItem.forEach((ele, index) => {
                        itemsIDsArr.push(ele.itemID)
                    });
                    let params = {
                        itemIDs: itemsIDsArr,
                        labelIDs: [],
                    }
                    this.setTagsRequset(params);
                }).catch(() => {

                });
            } else {
                this.$message.error('请先选择商品！');
                return;
            }


        },
        //库存详情
        storeClick(row) {
            let self = this;
            this.sorteHouseDialog = true;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminItem/GetPropList",
                params: {
                    itemID: row.itemID
                },
                success(res) {
                    self.storeList = res;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //修改商品
        editClick(row) {
            this.$router.push({
                'path': '/editGoods',
                'query': {
                    'itemID': row.itemID
                }
            })
        },
        //单个商品删除
        deleteClick(row, index) {
            let self = this;
            self.loading = true;
            this.$confirm('确认删除该商品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                $http.POST({
                    url: this.$store.state.apiUrl + "/api/services/app/AdminItem/DelItemVol",
                    data: {
                        itemIDs: [row.itemID]
                    },
                    success(res) {
                        self.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        self.goodsList.splice(index, 1);
                        self.loading = false;
                    },
                    fail(res) {
                        self.loading = false;
                    }
                })
            }).catch(() => {
                self.loading = false;
            });
        },
        //批量删除
        delChoosed() {
            let self = this;
            if (this.choosedItem.length) {
                this.$confirm('确认将所勾选的商品全部删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let itemsIDsArr = [];
                    self.choosedItem.forEach((ele, index) => {
                        itemsIDsArr.push(ele.itemID)
                    });
                    console.log(itemsIDsArr);
                    $http.POST({
                        url: self.$store.state.apiUrl + "/api/services/app/AdminItem/DelItemVol",
                        data: {
                            itemIDs: itemsIDsArr
                        },
                        success(res) {
                            self.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            self.serachForm.MaxResultCount = self.maxResultCount
                            self.getDatas(self.serachForm);
                            self.currentPage = 1
                            self.loading = false;
                        },
                        fail(res) {
                            self.loading = false;
                        }
                    })
                }).catch(() => {

                });
            } else {
                this.$message.error('请先选择商品！');
                return;
            }

        },
        //勾选单个表格
        handleSelectionChange(val) {
            this.choosedItem = val;
        },
        //一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
                Status: 2
            };
            this.getDatas(params);
        },
        //跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.serachForm;
            params.MaxResultCount = this.maxResultCount;
            params.skipCount = skipCount;
            this.getDatas(params);
        },

    }
}
</script>

<style lang='scss' scoped>
// 搜索栏
.searchBox {
    padding: 20px;
}
// 数据表格
.dataTable {
    margin: 20px;
    padding-bottom: 0;
    .tableBox {
        border: 1px solid #c5c5c5;
    }
    .goodBaseInfo {
        display: flex;
        align-items: center;
        .txtInfo {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            text-align: left;
            .title {
                font-size: 12px;
                color: #333;
            }
            .itemCode {
                font-size: 10px;
                color: #999;
            }
            .tags {
                display: flex;
                align-items: center;
                span {
                    height: 18px;
                    line-height: 18px;
                    font-style: normal;
                    font-size: 10px;
                    padding: 0px 8px;
                    color: #fff;
                    background: #999;
                    border-radius: 4px;
                    margin-right: 4px;
                }
                /deep/ .el-popover__reference {
                    cursor: pointer;
                    margin: 0;
                    padding: 0;
                }
            }
        }
        img {
            width: 50px;
            height: 50px;
            margin-right: 10px;
        }
    }
    .notice {
        display: inline-block;
        margin-right: 20px;
        i {
            font-style: normal;
            color: #f63b3b;
        }
    }
}
//高级搜索Dialog框
.searchDialog {
    .sale {
        display: flex;
        align-items: center;
        span {
            display: block;
            width: 125px;
            text-align: right;
            box-sizing: border-box;
            padding-right: 12px;
        }
        input {
            -webkit-appearance: none;
            background-color: #fff;
            background-image: none;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            color: #606266;
            display: inline-block;
            font-size: inherit;
            height: 40px;
            line-height: 40px;
            outline: 0;
            padding: 0 15px;
            -webkit-transition: border-color 0.2s
                cubic-bezier(0.645, 0.045, 0.355, 1);
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            width: 100px;
            height: 32px;
            outline: #409eff;
            appearance: normal;
        }
    }
    .searchDialogBtn {
        text-align: center;
    }
}
//批量设置标签dialog框
.setTagsDialog {
    .tagNotice {
        margin-bottom: 20px;
    }
    .tagsDialogBtn {
        text-align: right;
        margin-top: 20px;
    }
}

// 库存详情dialog框
</style>
<style lang="scss">
.goodsListCheckBox {
    display: flex;
    flex-direction: column;
    label {
        margin-left: 0 !important;
    }
}
</style>